import { useOverlays } from "contexts/OverlayContext";
import { useIsCategoryGlMappingEnabled } from "@hooks/useIsCategoryGlMappingEnabled";
import { PlainModal } from "@design-system/Modal/Modal";
import { CreateCategoryModal } from "./CreateCategoryModal";

export const CreateCategoryModalContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const isGlMappingEnabled = useIsCategoryGlMappingEnabled();
    const overlayInfo = getOverlayInfo("createCategory");

    if (!overlayInfo?.data) {
        return null;
    }

    const { parentCategoryId, categoryName, onCategoryCreated } =
        overlayInfo.data;

    return (
        <PlainModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            size={isGlMappingEnabled ? "lg" : "md"}
        >
            <CreateCategoryModal
                parentCategoryId={parentCategoryId}
                categoryName={categoryName}
                onCategoryCreated={onCategoryCreated}
                onHide={closeOverlay}
            />
        </PlainModal>
    );
};
